export class SetCompactView {
	static readonly type = '[Compact view] Set Compact View';

	constructor(public setCompactView: boolean) { }
}
